export const TEST = "TEST";
export const OBTIENE_ENCUESTAS = "OBTIENE_ENCUESTAS";
export const SET_FORMULARIO = "SET_FORMULARIO";
export const GET_INICIATIVAS = "GET_INICIATIVAS";

export const GET_ENTREGA_ENTRADA = "GET_ENTREGA_ENTRADA";
export const SET_ENTREGA_ENTRADA = "SET_ENTREGA_ENTRADA";

export const SET_PREGUNTA_ACTIVA = "SET_PREGUNTA_ACTIVA";

export const GET_USUARIO = "GET_USUARIO";

export const SET_ANSWER = "SET_ANSWER";
export const SET_ANSWERNEW = "SET_ANSWERNEW";

export const GET_TICKET = "GET_TICKET";
export const SET_RESPUESTA = "SET_RESPUESTA";
export const GET_ESTADO = "GET_ESTADO";
export const GET_REPORTE = "GET_REPORTE";

export const SET_PREGUNTA_CUATERNA = "SET_PREGUNTA_CUATERNA";
export const SET_PREGUNTA_LOCAL = "SET_PREGUNTA_LOCAL";
